import { z } from 'zod/v4';

import { ADFQuoteDocument } from './adf';
import { ANAQuoteDocument } from './ana';
import { ASMQuoteDocument } from './asm';
import { BTLQuoteDocument } from './btl';
import { CAPQuoteDocument } from './cap';
import { CSCQuoteDocument } from './csc';
import { DefaultQuoteDocument } from './default';
import { GREQuoteDocument } from './gre';
import { HPCQuoteDocument } from './hpc';
import { MMCQuoteDocument } from './mmc';
import { MWSQuoteDocument } from './mws';
import { RAFQuoteDocument } from './raf';
import { ROCQuoteDocument } from './roc';
import { SPMQuoteDocument } from './spm';
import { USAQuoteDocument } from './usa';
import { WWPQuoteDocument } from './wwp';

export const siteQuoteDocumentSchema = z.enum([
  'adf',
  'amf',
  'ana',
  'asm',
  'btl',
  'cap',
  'csc',
  'esp',
  'gre',
  'grs',
  'hpc',
  'hps',
  'mmc',
  'mps',
  'mws',
  'nor',
  'orp',
  'raf',
  'roc',
  'rum',
  'spm',
  'ssx',
  'svm',
  'tel',
  'usa',
  'wwp',
]);

export type SiteQuoteDocumentOption = z.infer<typeof siteQuoteDocumentSchema>;

export const siteQuoteDocuments: Record<
  SiteQuoteDocumentOption,
  React.ComponentType
> = {
  adf: ADFQuoteDocument,
  amf: DefaultQuoteDocument,
  ana: ANAQuoteDocument,
  asm: ASMQuoteDocument,
  btl: BTLQuoteDocument,
  cap: CAPQuoteDocument,
  csc: CSCQuoteDocument,
  esp: DefaultQuoteDocument,
  gre: GREQuoteDocument,
  grs: DefaultQuoteDocument,
  hpc: HPCQuoteDocument,
  hps: DefaultQuoteDocument,
  mmc: MMCQuoteDocument,
  mps: DefaultQuoteDocument,
  mws: MWSQuoteDocument,
  nor: DefaultQuoteDocument,
  orp: DefaultQuoteDocument,
  raf: RAFQuoteDocument,
  roc: ROCQuoteDocument,
  rum: DefaultQuoteDocument,
  spm: SPMQuoteDocument,
  ssx: DefaultQuoteDocument,
  svm: DefaultQuoteDocument,
  tel: DefaultQuoteDocument,
  usa: USAQuoteDocument,
  wwp: WWPQuoteDocument,
};
